import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const getUrlFn = httpsCallable(functions, 'getPandaDownloadUrl');

function sanitizeFilename(name) {
  // remove caracteres inválidos e limita tamanho
  return name
    .replace(/[\\\/:*?"<>|]/g, '')   // tira caracteres proibidos
    .trim()                          // limpa espaços nas bordas
    .substring(0, 100);              // não precisa de nomes gigantes
}

/**
 * Dispara download do vídeo no browser.
 * @param {Object} item — o objeto do vídeo vindo do Firestore
 * @returns {Promise<string>} — o videoId baixado
 */

export async function downloadVideo(item) {
  // 1) Extrai ID e título
  const externalId = item.pandaVideoMetadata?.video_external_id;
  const metadataId = item.videoInfo?.metadata?.id;
  const videoId = externalId ?? metadataId;
  if (!videoId) {
    throw new Error('ID do vídeo não encontrado.');
  }
  const rawTitle = item.title || videoId;
  const title = sanitizeFilename(rawTitle);

  // 2) Pega URL de download
  const result = await getUrlFn({ videoId });

  const url = result.data?.url;
  if (!url) {
    throw new Error('Não foi possível obter a URL de download.');
  }

  // 3) Baixa como blob para garantir a extensão .mp4 no nome final
  // (a URL da Panda é cross-origin e o navegador ignora o atributo
  // `download` nesse caso, salvando o arquivo sem extensão).
  const blobUrl = URL.createObjectURL(await (await fetch(url)).blob());

  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = `${title}.mp4`;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(blobUrl);

  return videoId;
}
